import type { DataTableFeatures } from 'design-system';

import type { CatalogItem } from '@/entities/catalog-item';

import type { Row } from '@tanstack/react-table';

export function isRowRestricted(
  row: Row<DataTableFeatures, CatalogItem>,
  isForwardCurves: boolean,
  isPermissionGranted: boolean
): boolean {
  if (!isPermissionGranted) return true;
  if (isForwardCurves) return false;
  const { Last, Change } = row.original;
  return !Last && !Change;
}
